import { z } from 'zod';

import { defaultNullish, mongoIdSchema } from './shared';

export enum BulkGroupStatus {
  // TODO: enums should be camelcased
  DRAFT = 'draft',
  COMPLETED = 'completed',
  PROCESSING = 'processing',
}

export const bulkGroupRawProductSchema = z.object({
  row: defaultNullish(z.number().default(0)),
  uniqueIdentifier: defaultNullish(z.string().trim().default('')),
  title: defaultNullish(z.string().trim().default('')),
  primaryKeyword: defaultNullish(z.string().trim().default('')),
  brandName: defaultNullish(z.string().trim().default('')),
  price: defaultNullish(z.string().trim().default('')),
  filesUrls: defaultNullish(z.array(z.string().trim()).default([])),
  allowedToScrapeSupplier: defaultNullish(z.boolean().default(true)),
  websiteUrl: defaultNullish(z.string().trim().default('')),
  extraInformation: defaultNullish(z.string().trim().default('')),
  productType: defaultNullish(z.string().trim().default('')),
  numberOfWords: defaultNullish(z.number().default(0)),
});

// NOTE: in the future we may want medias and processing progress
export const bulkGroupCreateSchema = z.object({
  title: z.string().min(1, 'FIELD_REQUIRED'),
  status: z.nativeEnum(BulkGroupStatus),
  language: z.string().trim(),
  country: z.string().trim(),
  author: mongoIdSchema,
  brandId: mongoIdSchema,
  templateId: mongoIdSchema,
  organizationId: mongoIdSchema,
  numberOfProducts: defaultNullish(z.number().default(0)),
  rawProducts: defaultNullish(z.array(bulkGroupRawProductSchema).default([])),
  areImagesRequired: z.boolean().optional(),
});

export type BulkGroupCreate = z.infer<typeof bulkGroupCreateSchema>;

export const bulkGroupSchema = z
  .object({
    _id: mongoIdSchema,
    isArchived: defaultNullish(z.boolean().default(false)),
    archivedDate: defaultNullish(z.number().default(0)),
    createdAt: z.number(),
    updatedAt: z.number(),
    startedProcessingAt: defaultNullish(z.number().nullish()).default(0),
  })
  .merge(bulkGroupCreateSchema);

export type BulkGroup = z.infer<typeof bulkGroupSchema>;

export const INSUFFICIENT_CREDITS_FOR_BULK_GENERATION = 'INSUFFICIENT_CREDITS_FOR_BULK_GENERATION';
export const UNREACHABLE_PRODUCT_IMAGE = 'UNREACHABLE_PRODUCT_IMAGE';
